export default __webpack_public_path__ + "static/media/RunHorseLight_3_1.6a3f3e79.jpg";